var map = {
	"./Account.svg": [
		90679,
		4736,
		679
	],
	"./AddComments.svg": [
		42650,
		4736,
		9351
	],
	"./Aparat.svg": [
		87762,
		4736,
		9351
	],
	"./ArrowDown.svg": [
		13874,
		4736,
		9351
	],
	"./ArrowLeft.svg": [
		46529,
		4736,
		9351
	],
	"./ArrowRight.svg": [
		63303,
		4736,
		9351
	],
	"./ArrowTop.svg": [
		9121,
		4736,
		9351
	],
	"./Award.svg": [
		49128,
		4736,
		9128
	],
	"./Back.svg": [
		25298,
		4736,
		9351
	],
	"./BackSquare.svg": [
		67090,
		4736,
		9351
	],
	"./Bag.svg": [
		43214,
		4736,
		9351
	],
	"./Bars.svg": [
		915,
		4736,
		9351
	],
	"./Bell.svg": [
		40624,
		4736,
		9351
	],
	"./Book.svg": [
		61848,
		4736,
		1848
	],
	"./Box.svg": [
		47600,
		4736,
		9351
	],
	"./BoxCheck.svg": [
		70757,
		4736,
		9351
	],
	"./BoxTick.svg": [
		11708,
		4736,
		9351
	],
	"./BoxTime.svg": [
		39421,
		4736,
		9351
	],
	"./Building.svg": [
		86945,
		4736,
		9351
	],
	"./BundlePlus.svg": [
		5272,
		4736,
		9351
	],
	"./CallAndWhatsApp.svg": [
		88005,
		4736,
		9351
	],
	"./CanceledOrder.svg": [
		2376,
		4736,
		9351
	],
	"./Card.svg": [
		32603,
		4736,
		9351
	],
	"./CardTick.svg": [
		25289,
		4736,
		9351
	],
	"./CardTickSmall.svg": [
		42140,
		4736,
		2140
	],
	"./CaretLeft.svg": [
		11612,
		4736,
		9351
	],
	"./CaretLeftV2.svg": [
		45517,
		4736,
		5517
	],
	"./CarryGoods.svg": [
		56641,
		4736,
		9351
	],
	"./Cart.svg": [
		98515,
		4736,
		9351
	],
	"./CatIcon.svg": [
		53038,
		4736,
		9351
	],
	"./CheckboxEmpty.svg": [
		81525,
		4736,
		9351
	],
	"./CheckboxFill.svg": [
		54692,
		4736,
		9351
	],
	"./Clock.svg": [
		31501,
		4736,
		9351
	],
	"./Close.svg": [
		38664,
		4736,
		9351
	],
	"./Close_v2.svg": [
		33649,
		4736,
		3649
	],
	"./Comments.svg": [
		75086,
		4736,
		9351
	],
	"./Comments2.svg": [
		23618,
		4736,
		9351
	],
	"./Compare.svg": [
		20684,
		4736,
		9351
	],
	"./ContactServices.svg": [
		64982,
		4736,
		9351
	],
	"./Copy.svg": [
		45412,
		4736,
		9351
	],
	"./CopySmall.svg": [
		20861,
		4736,
		9351
	],
	"./Coupon.svg": [
		76294,
		4736,
		9351
	],
	"./CurrentOrder.svg": [
		88023,
		4736,
		9351
	],
	"./DeliveredOrder.svg": [
		13509,
		4736,
		9351
	],
	"./Discount.svg": [
		50110,
		4736,
		9351
	],
	"./DiscountMenu.svg": [
		62941,
		4736,
		2941
	],
	"./Dislike.svg": [
		53721,
		4736,
		9351
	],
	"./DocServices.svg": [
		44402,
		4736,
		9351
	],
	"./Document.svg": [
		66741,
		4736,
		6741
	],
	"./Dot.svg": [
		23438,
		4736,
		9351
	],
	"./DownloadIcon.svg": [
		50615,
		4736,
		9351
	],
	"./Edit.svg": [
		63163,
		4736,
		9351
	],
	"./EditPen.svg": [
		63781,
		4736,
		9351
	],
	"./Excel.svg": [
		55884,
		4736,
		9351
	],
	"./Export.svg": [
		20132,
		4736,
		132
	],
	"./Eye.svg": [
		14812,
		4736,
		4812
	],
	"./FilePrice.svg": [
		73548,
		4736,
		9351
	],
	"./FileText.svg": [
		4588,
		4736,
		9351
	],
	"./Flash.svg": [
		87767,
		4736,
		7767
	],
	"./FreeDelivery.svg": [
		51576,
		4736,
		9351
	],
	"./Gift.svg": [
		81721,
		4736,
		9351
	],
	"./GiftSmall.svg": [
		48698,
		4736,
		9351
	],
	"./HamburgerMenu.svg": [
		43490,
		4736,
		9351
	],
	"./Heart.svg": [
		30211,
		4736,
		9351
	],
	"./Home.svg": [
		73950,
		4736,
		3950
	],
	"./Home2.svg": [
		48985,
		4736,
		9351
	],
	"./InPersonDelivery.svg": [
		8246,
		4736,
		9351
	],
	"./InfoCircle.svg": [
		19344,
		4736,
		9351
	],
	"./Instagram.svg": [
		40694,
		4736,
		9351
	],
	"./Invoice.svg": [
		70356,
		4736,
		9351
	],
	"./InvoiceServices.svg": [
		10776,
		4736,
		9351
	],
	"./InvoiceType.svg": [
		31384,
		4736,
		9351
	],
	"./LStarFilled.svg": [
		95919,
		4736,
		9351
	],
	"./LabelStar.svg": [
		10368,
		4736,
		368
	],
	"./Layers.svg": [
		21751,
		4736,
		9351
	],
	"./Like.svg": [
		24785,
		4736,
		9351
	],
	"./Linkedin.svg": [
		32753,
		4736,
		9351
	],
	"./Location.svg": [
		77750,
		4736,
		9351
	],
	"./LocationMap.svg": [
		66005,
		4736,
		9351
	],
	"./Lock.svg": [
		90423,
		4736,
		9351
	],
	"./Login.svg": [
		75161,
		4736,
		9351
	],
	"./Logout.svg": [
		37893,
		4736,
		9351
	],
	"./Mail.svg": [
		47683,
		4736,
		9351
	],
	"./MailBox.svg": [
		95151,
		4736,
		5151
	],
	"./MailPocket.svg": [
		54088,
		4736,
		4088
	],
	"./MainSearch.svg": [
		93,
		4736,
		9351
	],
	"./MapPin.svg": [
		5725,
		4736,
		9351
	],
	"./Medal.svg": [
		54950,
		4736,
		9351
	],
	"./MediumStar.svg": [
		12202,
		4736,
		9351
	],
	"./MenuButton.svg": [
		8977,
		4736,
		9351
	],
	"./MessageQuestion.svg": [
		71653,
		4736,
		9351
	],
	"./Messages.svg": [
		54761,
		4736,
		9351
	],
	"./MessagesSquare.svg": [
		43463,
		4736,
		9351
	],
	"./Minus.svg": [
		31116,
		4736,
		9351
	],
	"./Mobile.svg": [
		3760,
		4736,
		9351
	],
	"./Money.svg": [
		44687,
		4736,
		9351
	],
	"./More.svg": [
		75402,
		4736,
		9351
	],
	"./MoreButton.svg": [
		64285,
		4736,
		4285
	],
	"./Note.svg": [
		15482,
		4736,
		5482
	],
	"./Notification.svg": [
		21637,
		4736,
		9351
	],
	"./OpenBook.svg": [
		24600,
		4736,
		9351
	],
	"./Pdf.svg": [
		8666,
		4736,
		9351
	],
	"./PdfInvoice.svg": [
		35300,
		4736,
		9351
	],
	"./PerformServices.svg": [
		1210,
		4736,
		9351
	],
	"./Phone.svg": [
		81017,
		4736,
		9351
	],
	"./PhoneV2.svg": [
		59094,
		4736,
		9094
	],
	"./Pinterest.svg": [
		68843,
		4736,
		9351
	],
	"./Plus.svg": [
		52359,
		4736,
		9351
	],
	"./Post.svg": [
		75100,
		4736,
		9351
	],
	"./PreInvoice.svg": [
		25405,
		4736,
		5405
	],
	"./PriceList.svg": [
		77818,
		4736,
		9351
	],
	"./Print.svg": [
		96312,
		4736,
		9351
	],
	"./Printer.svg": [
		50858,
		4736,
		858
	],
	"./Profile.svg": [
		72424,
		4736,
		9351
	],
	"./QuestionWrap.svg": [
		18991,
		4736,
		9351
	],
	"./Receipt.svg": [
		6537,
		4736,
		9351
	],
	"./RepairProduct.svg": [
		66536,
		4736,
		9351
	],
	"./Request.svg": [
		13603,
		4736,
		9351
	],
	"./ReturnedButton.svg": [
		316,
		4736,
		316
	],
	"./ReturnedOrder.svg": [
		91413,
		4736,
		9351
	],
	"./RoundStarEmpty.svg": [
		88668,
		4736,
		8668
	],
	"./RoundStarEmptySmall.svg": [
		93220,
		4736,
		3220
	],
	"./RoundStarFill.svg": [
		38666,
		4736,
		8666
	],
	"./Search.svg": [
		82235,
		4736,
		9351
	],
	"./SearchList.svg": [
		51661,
		4736,
		9351
	],
	"./SearchNormal.svg": [
		65723,
		4736,
		9351
	],
	"./Setting.svg": [
		97620,
		4736,
		9351
	],
	"./Shield.svg": [
		55167,
		4736,
		9351
	],
	"./Shipping.svg": [
		37868,
		4736,
		9351
	],
	"./SmallArrowDown.svg": [
		78690,
		4736,
		9351
	],
	"./SmallArrowLeft.svg": [
		9365,
		4736,
		9351
	],
	"./SmallClock.svg": [
		45486,
		4736,
		5486
	],
	"./SmallClose.svg": [
		12207,
		4736,
		9351
	],
	"./SmallLocation.svg": [
		30049,
		4736,
		9351
	],
	"./SmallPdf.svg": [
		66576,
		4736,
		9351
	],
	"./SmallPhone.svg": [
		67038,
		4736,
		9351
	],
	"./SmallStar.svg": [
		25174,
		4736,
		9351
	],
	"./SmallUser.svg": [
		96968,
		4736,
		9351
	],
	"./Sms.svg": [
		95306,
		4736,
		9351
	],
	"./Sort.svg": [
		4613,
		4736,
		9351
	],
	"./Star.svg": [
		2469,
		4736,
		9351
	],
	"./Telegram.svg": [
		1585,
		4736,
		9351
	],
	"./TickCircle.svg": [
		32175,
		4736,
		9351
	],
	"./Ticket.svg": [
		66797,
		4736,
		9351
	],
	"./Toman.svg": [
		8699,
		4736,
		9351
	],
	"./Track.svg": [
		79873,
		4736,
		9351
	],
	"./Trash.svg": [
		86600,
		4736,
		9351
	],
	"./TrashWithX.svg": [
		62518,
		4736,
		9351
	],
	"./Truck.svg": [
		16025,
		4736,
		9351
	],
	"./Truck2.svg": [
		22992,
		4736,
		9351
	],
	"./Upload.svg": [
		79515,
		4736,
		9351
	],
	"./User.svg": [
		69515,
		4736,
		9351
	],
	"./Video.svg": [
		45699,
		4736,
		9351
	],
	"./Wallet.svg": [
		59966,
		4736,
		9351
	],
	"./Watch.svg": [
		85586,
		4736,
		9351
	],
	"./WhatsApp.svg": [
		24029,
		4736,
		9351
	],
	"./WhatsAppGreen.svg": [
		59984,
		4736,
		9351
	],
	"./WhatsAppGreenV2.svg": [
		80728,
		4736,
		9351
	],
	"./WhatsappSmall.svg": [
		11072,
		4736,
		9351
	],
	"./Youtube.svg": [
		3124,
		4736,
		9351
	],
	"./ZoomDetails.svg": [
		68405,
		4736,
		9351
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36663;
module.exports = webpackAsyncContext;